import Swal from "sweetalert2";
import { postTransportBrom } from "../services/transport.services";
import { compressor } from "./compressorjs";

export const onSubmit = async (data, setLoading) => {
  const {
    imgFront,
    imgSide,
    imgBack,
    DNIpdf,
    afip,
    deedpdf,
    VTVpdf,
    policy,
    payment,
    declaration,
    // office,
    legalPerson,
    food, //name de input carnet
  } = data;
  if (
    !imgFront[0] ||
    !imgSide[0] ||
    !imgBack[0] ||
    !DNIpdf[0] ||
    !afip[0] ||
    !deedpdf[0] ||
    !VTVpdf[0] ||
    !policy[0] ||
    !payment[0] ||
    // !office[0] ||
    !food[0]
  ) {
    return Swal.fire(
      "Error",
      "Debe enviar todos los documentos requeridos",
      "error"
    );
  }
  setLoading(true);
  let formData = new FormData();

  let front = await compressor(imgFront[0]);
  let side = await compressor(imgSide[0]);
  let back = await compressor(imgBack[0]);

  if (legalPerson) {
    for (let i = 0; i < legalPerson.length; i++) {
      formData.append("legalPerson", legalPerson[i], legalPerson[i].name);
    }
  }

  if (declaration) {
    formData.append("declaration", declaration[0], declaration[0].name);
  }

  formData.append("imgFront", front, front.name);
  formData.append("imgSide", side, side.name);
  formData.append("imgBack", back, back.name);
  formData.append("DNIpdf", DNIpdf[0], DNIpdf[0].name);
  formData.append("afip", afip[0], afip[0].name);
  formData.append("deedpdf", deedpdf[0], deedpdf[0].name);
  formData.append("VTVpdf", VTVpdf[0], VTVpdf[0].name);
  formData.append("policy", policy[0], policy[0].name);
  formData.append("payment", payment[0], payment[0].name);
  // formData.append("office", office[0], office[0].name);
  formData.append("food", food[0], food[0].name);
  formData.append("values", JSON.stringify(data));

  const res = await postTransportBrom(formData);

  if (res.status === 201) {
    setLoading(false);
    Swal.fire({
      title: "Exito",
      text: "Trámite iniciado con éxito. Evaluaremos la documentación enviada y se le notificará vía correo electrónico",
      icon: "success",
      willClose: () => window.location.replace("/"),
    });
  } else {
    setLoading(false);
    Swal.fire({
      title: "Error",
      text: "Ocurrió un error al registrarse. Intente nuevamente",
      icon: "error",
      willClose: () => window.location.replace("/"),
    });
  }
  setLoading(false);
};
